import React, { memo } from 'react'
import CircularProgress from '@alobato/circular-progress'
import { Formik } from 'formik'
import * as Yup from 'yup'
import '../../validators'

import FormModal from '../../components/FormModal'
import Form from './Form'
import useCatalogos from '../../hooks/useCatalogos'
import { enviarCadastro } from '../../lib/enviarCadastro'

import BASE_API from '../../constants/baseApi'

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  login: Yup.string().email().required(),
  password: Yup.string().min(6).required(),
  cpf: Yup.string().matches(/^[0-9]*$/, 'Somente números')
})

const New = ({ onRequestClose, onCreated, constantes, planos }) => {
  const initialValues = {
    name: '', login: '', password: '', cpf: '', birth_date: '', cellphone: '',
    gender: '', orientation: '', ethnicity: '',
    health_insurance: '', other_health_insurance: '',
    blood_type: '', rh_factor: '', alimentation: '', physical_activity: '',
    smoke: '', alcohol: '', drug: '',
    allergies: '', family_history: '', continuous_medications: ''
  }

  const handleSubmit = async (values, actions) => {
    const salvou = await enviarCadastro({
      url: `${BASE_API}/patient/`, method: 'POST', values, actions
    })
    if (!salvou) return
    onCreated()
    onRequestClose()
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
      render={props => (
        <FormModal title='Novo Paciente' onRequestClose={onRequestClose}
          onSubmit={props.handleSubmit} submitting={props.isSubmitting} error={props.status}>
          <Form {...props} isCreating constantes={constantes} planos={planos} />
        </FormModal>
      )}
    />
  )
}

export default memo(props => {
  const catalogos = useCatalogos({ constantes: true })
  if (catalogos.carregando) return <CircularProgress color='hsla(199, 75%, 43%, 1)' />
  return <New {...props} constantes={catalogos.constantes} planos={catalogos.planos} />
})
